import { CheckIcon, CopyIcon, InfoCircledIcon } from "@radix-ui/react-icons";
import { Flex, Spinner, Text, IconButton } from "@radix-ui/themes";
import useTrackPins from "../hooks/useTrackPins";

const TrackPinsStatus = () => {
  const { trackPinsStatus, copyTrackPinsTimestamp, copiedTimestamp } =
    useTrackPins();

  return (
    <Flex
      align="center"
      justify="center"
      gap="2"
      className="bg-black bg-opacity-60 px-3 py-2 rounded-md"
    >
      <Flex className="w-4 h-4" align="center" justify="center">
        {trackPinsStatus?.showSpinner ? (
          <Spinner size="1" className="text-white" />
        ) : (
          <InfoCircledIcon className="text-white" />
        )}
      </Flex>
      <Text className="text-white" highContrast size="2">
        {trackPinsStatus?.message}
      </Text>
      {trackPinsStatus?.timestamp && (
        <IconButton
          size="2"
          variant="ghost"
          className="text-white hover:bg-white hover:bg-opacity-20"
          onClick={() => copyTrackPinsTimestamp(trackPinsStatus.timestamp)}
        >
          {copiedTimestamp === trackPinsStatus.timestamp ? (
            <CheckIcon fontSize={20} />
          ) : (
            <CopyIcon fontSize={20} />
          )}
        </IconButton>
      )}
    </Flex>
  );
};

export default TrackPinsStatus;
